export const facebookConstants = {
    FACEBOOK_PROFILE_PAGES_SUCCESS: 'FACEBOOK_PROFILE_PAGES_SUCCESS',
    FACEBOOK_PROFILE_PAGES_ERROR: 'FACEBOOK_PROFILE_PAGES_ERROR',
    FACEBOOK_PROFILE_PAGES_REQUEST: 'FACEBOOK_PROFILE_PAGES_REQUEST',
    FACEBOOK_PROFILE_PAGES_RESET: 'FACEBOOK_PROFILE_PAGES_RESET',

    FACEBOOK_LISTING_PROFILE_SUCCESS: 'FACEBOOK_LISTING_PROFILE_SUCCESS',
    FACEBOOK_LISTING_PROFILE_ERROR: 'FACEBOOK_LISTING_PROFILE_ERROR',
    FACEBOOK_LISTING_PROFILE_REQUEST: 'FACEBOOK_LISTING_PROFILE_REQUEST',
};
